module.exports = __webpack_public_path__ + "static/bg-lottery.e536975f.png";